import type { BaseController } from '@infra/controllers/base.controller';
import type { MuteAgentCallUsecase } from './mute-agent.usecase';

export type MuteAgentInput = {
  onMute: boolean;
};

export type MuteAgentOutput = void;

export class MuteAgentController
  implements BaseController<MuteAgentInput, MuteAgentOutput>
{
  constructor(private usecase: MuteAgentCallUsecase) {}

  async handle(req: MuteAgentInput): Promise<MuteAgentOutput> {
    await this.usecase.run(req.onMute);
  }
}
